module.exports = __webpack_public_path__ + "static/media/panda-partners-4.a4e0271d.svg";